module.exports = __webpack_public_path__ + "media/מיץ.2585cc61.mp3";